import { InformationCircleIcon as WarningIcon } from '@heroicons/react/24/solid';

type WarningMessageProps = {
  content: React.ReactNode;
  testId: string;
};

const WarningMessage: React.FC<WarningMessageProps> = ({ content, testId }) => (
  <div
    className="warning-alert mt-3 kiosk:mt-6 kiosk:text-xl"
    data-testid={testId}
  >
    <div className="mx-2 kiosk:mx-4">
      <WarningIcon className="size-7 kiosk:size-10 text-warning-default" />
    </div>
    <span className="kiosk:text-2xl! ">
      {content}
    </span>
  </div>
);

export default WarningMessage;
